var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin":"0"},attrs:{"text":"","href":_vm.value,"target":"_blank","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("insert_link")]),_vm._v(" URL ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }